import { createSelector } from 'reselect';
import { activeSelector } from 'selectors/testTarget/offers/optimizeShippingCopyPLP/active/activeSelector';
import { isTestTargetReadySelector } from 'viewModel/selectors/testTarget/isTestTargetReadySelector';

const activeOptimizeShippingCopyPLPSelector = createSelector(isTestTargetReadySelector, activeSelector, (testReady, active) => testReady && active);

export { activeOptimizeShippingCopyPLPSelector };
